import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ArticleStyles = makeStyles((theme) => ({
  container: {
    padding: "10px 20px 1rem",
    color: COLORS.DARK_GRAY_2,
    fontSize: "1.25rem"
  },
  articleContainer: {
    paddingRight: 20,
    "& img": { width: "100%", height: "auto" }
  },
  header: {
    margin: "2rem 0 0"
  },
  summary: { marginBottom: "1rem" }
}));

export default ArticleStyles;
